import { render, staticRenderFns } from "./CupomRecomendacaoForm.vue?vue&type=template&id=591dc68f&"
import script from "./CupomRecomendacaoForm.vue?vue&type=script&lang=js&"
export * from "./CupomRecomendacaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports